import yup from 'core/utilities/Yup/YupMethods';

export default yup;
